import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Flex, Text, Button, Modal, Dropdown } from "samba-ui";
import NameInput from "./NameInput";

// TODO connect store here and check for name, if it is already created, show error

const CreateNewCampaignModal = ({ isOpen, onClose, onSubmit }) => {
  const [nameError, setNameError] = useState("");
  const [campaignName, setCampaignName] = useState("");
  const [country, setCountry] = useState("US");
  const [countryError, setCountryError] = useState("");
  
  const countries = [
    { value: "US", label: "US" },
    { value: "UK", label: "UK" },
    { value: "DE", label: "DE" },
    { value: "AU", label: "AU" }
  ];
  
  const clearState = () => {
    setCampaignName("");
    setCountry("US");
    setNameError("");
    setCountryError("");
  };
  
  const disabled = nameError || !campaignName || countryError || !country;
  return (
    <Modal width={700} isOpen={isOpen} onRequestClose={onClose}>
      <Modal.Header borderColor="#d6d6d6 !important">
        <Text>Create Campaign</Text>
      </Modal.Header>
      <Modal.Content minHeight={200} >
        <Flex alignItems="center" justifyContent="space-between" mb={3} >
          <Text>Campaign Name</Text>
          <NameInput
            value={campaignName}
            setValue={setCampaignName}
            error={nameError}
            setError={setNameError}
          />
        </Flex>
        <Flex alignItems="center" justifyContent="space-between">
          <Text>Country</Text>
          <Box width="200px">
            <Dropdown
              menuHeight="150px"
              options={countries}
              selected={countries.find(c => c.value === country) || null}
              onSelect={(selected) => {
                setCountry(selected.value);
                setCountryError("");
              }}
              maxHeight={300}
            />
          </Box>
        </Flex>
      </Modal.Content>
      <Modal.Actions justifyContent="flex-end" borderColor="#d6d6d6 !important">
        <Flex>
          <Box mr={3}>
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
          </Box>
          <Button
            disabled={disabled}
            variant="primaryBordered"
            onClick={() => {
              clearState();
              onSubmit({ name: campaignName, country });
            }}
          >
            Create
          </Button>
        </Flex>
      </Modal.Actions>
    </Modal>
  );
};
CreateNewCampaignModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};
export default CreateNewCampaignModal;
